import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { ActionStatus } from '@/application/types';
import { mediumMap, mediaServerUrl500 } from '@/helpers/data';
import { showSuccess } from '@/application/snackbar/service';
import { Medium } from '@/domain/types';
import ImageWithFallback from '@/domain/product-search/components/image-with-fallback/image-with-fallback.vue';
import { ProductRelatedCalendars, RelatedProduct } from '../../types';

const productSearchState = namespace('productSearch');

@Component({
  components: {
    ImageWithFallback,
  },
})
export default class RelatedCalendarsTab extends Vue {

  @productSearchState.State
  readonly getProductIdentificationsByEANStatus!: ActionStatus;

  @productSearchState.State
  readonly getProductIdentificationStatus!: ActionStatus;

  @productSearchState.State
  readonly getProductRelatedCalendarsStatus!: ActionStatus;

  @productSearchState.State
  readonly currentProductRelatedCalendars!: ProductRelatedCalendars | null;

  readonly mediaServerUrl500 = mediaServerUrl500;

  areNotDeliverableProductsHidden = true;

  get isLoadingProductIdentification(): boolean {
    return this.getProductIdentificationStatus === ActionStatus.InProgress
      || this.getProductIdentificationsByEANStatus === ActionStatus.InProgress;
  }

  get isLoadingProductRelatedCalendars(): boolean {
    return this.isLoadingProductIdentification
      || this.getProductRelatedCalendarsStatus === ActionStatus.InProgress;
  }

  get relatedProductsFiltered(): RelatedProduct[] {
    if (!this.currentProductRelatedCalendars) {
      return [];
    }

    if (this.areNotDeliverableProductsHidden) {
      return this.currentProductRelatedCalendars.products.filter((relatedProduct) => relatedProduct.isDeliverable);
    }

    return this.currentProductRelatedCalendars.products;
  }

  get productRelatedCalendarsAvailable(): boolean {
    return !this.isLoadingProductRelatedCalendars && !!this.currentProductRelatedCalendars;
  }

  get productRelatedCalendarsCouldNotBeLoaded(): boolean {
    return !this.isLoadingProductRelatedCalendars && !this.currentProductRelatedCalendars;
  }

  translatedMedium(medium: Medium): string {
    return mediumMap[medium];
  }

  onCopyEANSClicked(): void {
    if (!this.currentProductRelatedCalendars) {
      return;
    }

    let text = '';
    const productCount = this.relatedProductsFiltered.length;
    this.relatedProductsFiltered.forEach((product, index) => {
      text += product.ean;
      if (index < productCount - 1) {
        text += '\n';
      }
    });
    navigator.clipboard.writeText(text)
      .then(() => {
        showSuccess({ message: 'EANs in Zwischenablage kopiert' });
      });
  }

}
